<template>
<div class="row">
	<div class="col-md-8 first-column">
		<div class="row m-2">
			<div class="col-md-12 col-xs-12 col-xs-12">
				<div class="row share-campaign-wrapper">
					<div class="col-md-12 col-xs-12 col-xs-12 webpage-image-title margin-top-10 margin-bottom-30 margin-top-20 campaign-name">
						{{campaignData.name}}
					</div>
				</div>
				<div class="row">
					<div id="campaign_images">
						<swiper ref="campaignSwiper" class="campaign-media-wrapper mb-0" :options="swiperOptions">
							<swiper-slide v-for="image in campaignImages" :key="image.url" data-swiper-autoplay="3000">
								<div>
									<img :src="image.url" class="campaign-image campaign-media-img w-100" alt="campaign image"/>
								</div>

							</swiper-slide>
							<div class="swiper-pagination" slot="pagination"></div>
						</swiper>
					</div>
				</div>
			</div>
			<div class="col-md-12 col-xs-12">
				<div class="webpage-donations-box margin-top-50 margin-bottom-50">
					<div class="row">
						<div class="col-md-12 col-xs-12" id="donation_share">
							<div class="col-md-6  col-xs-12 donation-box" style="height: 100px; margin: 10px; filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25)); background: white;" >
								<div class="col-md-3 col-xs-3 padding-left-0 padding-right-0 flex-container flex-center margin-top-10">
									<div class="w-50">
										<img class="img-responsive img-circle" alt="campaign logo"
											:src="staticData.defaultLogoPath"
											style="width: 100%; height: 100%;">
									</div>
								</div>
								<div class="col-md-6  col-xs-6 padding-left-0 padding-right-0  text-center user-donation-name margin-top-10" style="font-family: Circular Std;
											font-style: normal;
											font-weight: 500;
											font-size: 16px;
											line-height: 16px;
											/* identical to box height, or 133% */
											
											
											color: #3E3E3E;
											">
												Anonymous
								</div>
								<div class="col-md-6  col-xs-6 padding-left-0 padding-right-0  text-center user-donation-amount margin-top-10" style="font-family: Circular Std;
											font-style: normal;
											font-weight: 500;
											font-size: 24px;
											line-height: 18px;
											/* identical to box height, or 112% */
											
											text-align: center;
											letter-spacing: 0.005em;
											
											color: #2FB09B;">
												$100
								</div>
								<div class="col-md-6  col-xs-12 padding-left-0 padding-right-0  text-center user-donation-time margin-top-10" style="font-family: Circular Std;
											font-style: normal;
											font-weight: 450;
											font-size: 15px;
											line-height: 10px;
											text-align: center;
											color: #A5A5A5;">
									2 days, 5 hours ago
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row margin-bottom-0 margin-bottom-20" style="margin-left: 2rem;">
			<div class="col-md-12 col-xs-12 col-xs-12 cause-details margin-bottom-50">
				<div class="row">
					<div class="col-xs-12 margin-bottom-50 campaign-preview-details-wrapper padding-right-0 margin-left-0">
						<div class="flex-container">
							<p class="width-100" style="font-family: Circular Std;
							font-size: 26px;
							font-style: normal;
							font-weight: 700;
							line-height: 26px;
							letter-spacing: 0em;
							text-align: left; color: black;
							">
								Cause Details
							</p>
						</div>
						<div class="campaign-category">
							<p style="font-family: Circular Std;
							font-size: 12px;
							font-style: normal;
							font-weight: 500;
							line-height: 15px;
							letter-spacing: 0.005em;
							text-align: right; border: 1px solid #EA641E; color: #EA641E;     padding: 1rem 5rem; border-radius: 9px; margin-top: -0.7rem; margin-left: 3rem;">
								{{campaignData.category.label}}
							</p>
						</div>
					</div>
					<div class="col-xs-12">
						<div class=" cause-details-description" >
						
							<div  id="all-details" style="font-family: Circular Std;
							font-size: 18px;
							font-style: normal;
							font-weight: 450;
							line-height: 34px;
							letter-spacing: 0em;
							text-align: left; color: #707070;" v-html="campaignData.campaign_blurb">
						
							</div>
							
							<p style="font-family: Circular Std;
							font-size: 14px;
							font-style: normal;
							font-weight: 700;
							line-height: 18px;
							letter-spacing: 0.005em;
							text-align: left; color: #404040; margin-top: 2rem; cursor: pointer;
							" id="showMore"> READ MORE </p>
							<hr style="border: 1px solid #A5A8AB;"> 
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-xs-12 margin-bottom-50 campaign-details-wrapper padding-right-0" style="margin-left: 2rem;">
				<div class="flex-container">
					<div class="cause-details-title width-100" style="font-family: Circular Std;
					font-size: 26px;
					font-style: normal;
					font-weight: 700;
					line-height: 26px;
					letter-spacing: 0em;
					text-align: left; color: black;
					">
						Comments
					</div>
				</div>
			</div>
		</div>
		<div class="row cause-comments" style="padding-left: 0px; margin-left: 2rem;">
			<div class="cause-comments-items" id="support_comments">					
				<div class="margin-bottom-50" style="display: flex; align-items: center;">
					<div class="">									
						<img class="img-responsive img-circle logo-img" :src="staticData.defaultLogoPath" alt="user-image">
					</div>
					<div class="margin-left-10 text-left">		
							<div class="comment-user-name" style="font-family: Circular Std;
font-style: normal;
font-weight: 500;
font-size: 16px;
line-height: 16px;
color: #3E3E3E;">Anonymous</div>								
						<div class="comment-content" style="font-family: Circular Std;
font-style: normal;
font-weight: 450;
font-size: 14px;
line-height: 24px;
color: #8A8A8A;">Example Comment</div>
					</div>
				</div>						
			</div>
		</div>
	</div>
	<div class="col-md-4 col-xs-4 second-column">	
		<div class="webpage-donations-box margin-top-50">
			<div class="row margin-bottom-20">
				<div class="webpage-donations-box-title col-md-8 col-xs-8"  style="
				font-family: Circular Std;
				font-style: normal;
				font-weight: bold;
				font-size: 26px;
				line-height: 26px; color: black">
					<span>$100</span> of ${{ campaignData.goal_amount }}
				</div>
				<div class="col-md-4 col-xs-4">
					<p style="font-family: Circular Std;
					font-style: normal;
					font-weight: 500;
					font-size: 16px;
					line-height: 16px;			
					margin-top: 0.5rem; float: right;
					color: #EA641E;"> {{campaignData.days_left}} Days Left
					</p>
				</div>
			</div>
		</div>
		<div class="progress margin-top-10 margin-bottom-10" style="height: 10px; background: #F4F4F0;">
			<div class="progress-bar progress-bar-success" role="progressbar" name="Campaign progress"
				aria-valuenow="10" aria-valuemin="0"
				aria-valuemax="100"
				style="width: 10%; background: #FFD76C; box-shadow: none;">
				<div class="progress-bar-percentage" style="position: absolute; ; left: 8%;">
				
						<span style="font-weight: bold; color: #F8F8F8 !important;"
							class="glyphicon glyphicon-chevron-up"></span>
						<br>
						<p class="percentage-orange-text" style="background: #FFFFFF;
						box-shadow: 0px 0px 6pxrgba(0, 0, 0, 0.08);
						border-radius: 2px;
						color: #EA641E; 
						font-family: Circular Std;
						font-size: 14px;
						font-style: normal;
						font-weight: 600;
						line-height: 15px;
						letter-spacing: 0em;">10% </p>
				
				</div> 
				<span class="sr-only">10% Complete</span>
			</div>
		</div>	
		<div class="row margin-top-50">
			<div class="col-md-12 col-xs-12 webpage-donations-box-contact">
				<span class="form-control organizer-info" style="text-align: left; font-family: Circular Std;
					font-size: 13px;
					font-style: normal;
					font-weight: 500;
					line-height: 26px;
					letter-spacing: 0em;
					text-align: left; color: #777373; color: #777373;opacity: 0.5;text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);">
					Organizer Info
				</span>
			</div>
		</div>
		<div class="row margin-top-10">
			<div class="col-md-3 col-xs-3">
				<div class="width-100">
					<img class="img-responsive img-circle" alt="campaign logo"
						:src="campaignLogoUrl">
				</div>
			</div>
			<div class="col-md-6  col-xs-6 text-center margin-top-10">
				<div class="company-details margin-top-5" style="font-family: Circular Std;
				font-size: 12px;
				font-style: normal;
				font-weight: 400;
				line-height: 14px;
				letter-spacing: 0em;
				text-align: left; color: #707070;
				">
					{{ campaignData.created_at }} {{campaignData.city}}, {{campaignData.state}}
				</div>
				<div class="company-name margin-top-10" style="font-family: Circular Std;
				font-size: 12px;
				font-style: normal;
				font-weight: 500;
				line-height: 13px;
				letter-spacing: 0em;
				text-align: left; color: #333333;
				">
					{{campaignData.contact_name }}
				</div>
			</div>
		</div>

		<div class="row" style="margin-right: 0px;">
			<div class="webpage-donations-box-statistics" style="text-align: right; font-family: Circular Std;
			font-size: 16px;
			font-style: normal;
			font-weight: 500;
			line-height: 16px;
			letter-spacing: 0em;
				color: #747474;
			">
				10 Supporters
			</div>
		</div>
		<div class="row margin-top-20 margin-bottom-20 filter-shadow-row" style="background: #F8FAFD; height: 75px; margin-right: 0px; margin-left: 0px;">
			<div class="col-md-5 col-xs-5">
				<p style="font-family: Circular Std;
				font-size: 14px;
				font-style: normal;
				font-weight: 500;
				line-height: 18px;
				letter-spacing: 0.005em;
				text-align: left; color:#A6A6A6; margin-top: 3rem;"> 
					{{campaignData.category.label}}
				</p>
			</div>
			
			<div class="col-md-7 col-xs-7">
				<a 
				class="btn hh-btn hh-btn-lg hh-btn-preview margin-top-10">Donate</a>
			</div>
		</div>
		<div class="row" style="background: white; height: 150px;">
			<div style="margin-top: 2rem;">
				<div class="col-md-6 col-xs-6">
				<p style="font-family: Circular Std;
				font-size: 16px;
				font-style: normal;
				font-weight: 700;
				line-height: 26px;
				letter-spacing: 0em;
				text-align: left; color: black;
				"> Connect and Share </p>
				</div>
				<div class="col-md-4 col-xs-4 ">
				<p style="font-family: Circular Std;
				font-size: 13px;
				font-style: normal;
				font-weight: 500;
				line-height: 26px;
				letter-spacing: 0em;
				text-align: right; color: #777373;
				"> Copy URL  </p>
				</div>
				
				<div class="col-md-2 col-xs-2 ">
			
				</div>
				<div class="col-md-12 col-xs-12 ">
					<div class="col-md-1 col-xs-1">
					<a :href="campaignData.instagram_page" target="_blank">
						<img :src="instagramUrl" alt="instagram" class="w-33">
					</a>
				</div>
					<div class="col-md-1 col-xs-1 margin-left-10" >
					<a :href="campaignData.twitter_page" target="_blank">
						<img :src="twitterUrl" alt="twitter" class="w-33">
					</a>
				</div>
					<div class="col-md-1 col-xs-1 margin-left-10">
					<a :href="campaignData.facebook_page" target="_blank">
						<img :src="facebookUrl" alt="facebook" class="w-33">
					</a>
					</div>
					<div class="col-md-8 col-xs-8 col-md-offset-1 col-xs-offset-1 margin-top-5">
							<div class="webpage-share-statistics">
								<img data-src="/dist/site/static/icons/shares.svg" alt="shares">									
								<span class="webpage-share-statistics-span text-right">20 Shares</span> 
							</div>
					</div>
				</div>
			</div>
				
		
			<div class="col-md-6 col-xs-6">
			</div>
		</div>
	</div>
</div>

</template>

<script>
	import InputLabel from '../form/elements/InputLabel'

	export default {
		name: 'Campaign',

		components: {
			InputLabel,
		},

		props: {
			campaignData: Object,
			campaignImages: Object,
			staticData: {
				states: Object,
				defaultLogoPath: String,
				defaultLogoName: String,
			},
		},

		data: () => {
			return {
				loading: true,
				dataAnalysed: false,
				campaignSlug: null,
				componentsLoadingStatus: {},
				swiperOptions: {
					slidesPerView: 1,
					centeredSlides: true,
					centeredSlidesBounds: true,
					pagination: {
						el: '.swiper-pagination',
						clickable: true,
						type: 'bullets',
					},
					autoplay: true,
				},
				instagramUrl: '/dist/site/static/icons/instagram.svg',
				twitterUrl: '/dist/site/static/icons/twitter.svg',
				facebookUrl: '/dist/site/static/icons/facebook.svg'

			}
		},

		beforeMount() {
			this.campaignSlug = this.campaignData.slug

			this.loading = false
		},

		mounted() {
			// this.swiper.slideTo(1, 1000, false)
		},

		methods: {

			componentLoading(componentName, value) {
				this.componentsLoadingStatus[componentName] = value
			},


		},

		computed: {
			isDataFetched() {
				return !_.isEmpty(this.campaignData)
			},

			isLoading() {
				for (let component in this.componentsLoadingStatus) {
					if (this.componentsLoadingStatus[component]) {
						return true
					}
				}

				return this.loading
			},

			campaignLogoUrl() {
				if (_.isEmpty(this.campaignData.logo_url)) {
					return this.staticData.defaultLogoPath
				}

				return this.campaignData.logo_url
			},

			swiper() {
				return this.$refs.campaignSwiper.$swiper
			},
		},

		watch: {
			isLoading(to, from) {
				this.$emit('componentLoading', 'campaignComponent', to)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.webpage-share-statistics-span {
		font-family: Circular Std;
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: 16px;
		letter-spacing: 0em;
		text-align: left; color: #707070;
	}
	.container {
	width:1500px;
	}

	.first-column {
		width:65%; margin-right:2%; background: white; filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));  border: 1px solid white;  border-radius: 10px;
	}

	.second-column {
		width: 33%; background: white; filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));     border: 1px solid white; border-radius: 10px;
	}

	@media screen and (max-width: 991px ) {
		.second-column, .first-column {
			width: 100% !important;
		}
		
		.donation-box {
			height: 120px !important;
		}

		.display-sm-none {
			display: none !important;
		}

		.img-circle {
			width: 45px !important;
		}

		.filter-shadow-row {
			filter: none !important;
			height: auto !important;

		}

		.recaptcha-wrapper {
			width: 80% !important;
		}
	}

	.slick-dots {
		display: none;
	}

	.campaign-name {
		font-family: Circular Std;
		font-size: 30px;
		font-style: normal;
		font-weight: 900;
		line-height: 26px;
		letter-spacing: 0em;
		text-align: left; color: black;
	}

	.m-2 {
		margin: 2rem;
	}

	.mb-0 {
		margin-bottom: 0;
	}

	.w-100 {
		width: 100%;
	}

	.w-33 {
		width: 33px;
	}

	.w-50 {
		width: 50px;
	}
	/*.swiper-container {*/
	/*		padding-bottom: 60px;*/
	/*}*/

	/*.swiper-pagination::v-deep {*/
	/*		bottom: 0 !important;*/

	/*		.swiper-pagination-bullet {*/
	/*				opacity: .3 ;*/
	/*				width: 14px;*/
	/*				height: 14px;*/
	/*				background: red 0% 0% no-repeat padding-box !important;*/

	/*				&.swiper-pagination-bullet-active {*/
	/*						opacity: .6;*/
	/*				}*/
	/*		}*/
	/*}*/

</style>
